import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  signOut as fbSignOut,
  onAuthStateChanged,
  connectAuthEmulator,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { app } from "./firebase.js";

export const auth = getAuth(app);

if (import.meta.env?.DEV) {
  const host = typeof window !== "undefined" ? window.location.hostname : "127.0.0.1";
  try {
    connectAuthEmulator(auth, `http://${host}:9099`);
  } catch (error) {
    if (error.code !== "auth/emulator-config-failed") {
      console.error("Auth emulator connection error:", error);
    }
  }
}

if (typeof window !== "undefined" && sessionStorage.getItem("firebase_redirect_pending")) {
  sessionStorage.removeItem("firebase_redirect_pending");
  getRedirectResult(auth).catch((error) => {
    console.error("Firebase redirect sign-in error:", error);
    alert("Pāradresācijas pieteikšanās kļūda: " + error.message);
  });
}

const provider = new GoogleAuthProvider();

export function signIn() {
  sessionStorage.clear();

  let promise;
  if (typeof window !== "undefined" && window.__mockPopupBlocked) {
    const error = new Error("Mock popup blocked");
    error.code = "auth/popup-blocked";
    promise = Promise.reject(error);
  } else {
    promise = signInWithPopup(auth, provider);
  }

  return promise.catch((error) => {
    if (
      error.code === "auth/popup-blocked" ||
      error.code === "auth/operation-not-supported-in-this-environment"
    ) {
      sessionStorage.setItem("firebase_redirect_pending", "1");
      return signInWithRedirect(auth, provider);
    }
    throw error;
  });
}

export function signOut() {
  sessionStorage.clear();
  return fbSignOut(auth);
}

export function onAuthChange(cb) {
  return onAuthStateChanged(auth, cb);
}

export function signInWithEmail(email, password) {
  return signInWithEmailAndPassword(auth, email, password);
}

export function signUpWithEmail(email, password) {
  return createUserWithEmailAndPassword(auth, email, password);
}

if (import.meta.env?.DEV && typeof window !== "undefined") {
  window.__testSignInWithEmail = (email, password) =>
    signInWithEmailAndPassword(auth, email, password);
}
